export const SvgClose = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3499 4.64891C15.6813 4.98026 15.6813 5.51749 15.3499 5.84885L5.84689 15.3519C5.51554 15.6832 4.97831 15.6832 4.64695 15.3519C4.3156 15.0205 4.3156 14.4833 4.64695 14.1519L14.15 4.64891C14.4813 4.31755 15.0186 4.31755 15.3499 4.64891Z"
        fill="#292D32"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.64695 4.64891C4.97831 4.31755 5.51554 4.31755 5.84689 4.64891L15.3499 14.1519C15.6813 14.4833 15.6813 15.0205 15.3499 15.3519C15.0186 15.6832 14.4813 15.6832 14.15 15.3519L4.64695 5.84885C4.3156 5.51749 4.3156 4.98026 4.64695 4.64891Z"
        fill="#292D32"
      />
    </svg>
  );
};
